import { render, staticRenderFns } from "./NewSupplierBtn.vue?vue&type=template&id=6dc3ebfb&scoped=true&"
import script from "./NewSupplierBtn.vue?vue&type=script&lang=js&"
export * from "./NewSupplierBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc3ebfb",
  null
  
)

export default component.exports